import { JOIN_ALLOCATION_PERSONAL_INFO_FORM } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/JoinAndAllocationPersonalDetails/JoinAndAllocationPersonalInformation/useJoinAndAllocationPersonalInformationController.tsx';
import { getMainAddress } from '@dealstack/frontend/shared/address.ts';
import { DataShareholderInvestorWithPersonRes } from '@dealstack/shared/lib/generated';
import { INVESTMENT_LEAVE_PERSONAL_INFO_FORM } from '@dealstack/frontend/investor/pages/Investment/InvestmentLeave/InvestmentLeavePersonalDetails/InvestmentLeavePersonalInformation/useInvestmentLeavePersonalInformationController.tsx';

export const getFormValuesFromInvestorData = (
	data: DataShareholderInvestorWithPersonRes,
	form: typeof JOIN_ALLOCATION_PERSONAL_INFO_FORM | typeof INVESTMENT_LEAVE_PERSONAL_INFO_FORM
) => {
	const person = data.person;
	const personPhoneNumber = `${person?.telephonePrefix ?? ''} ${person?.phoneNumber ?? ''}`;
	const personAddress = getMainAddress(person?.addresses);

	return {
		[form.FIRST_NAME]: person?.firstName,
		[form.LAST_NAME]: person?.lastName,
		[form.BIRTH_DATE]: person?.dateOfBirth ?? '',
		[form.COUNTRY]: personAddress?.country,
		[form.CITY]: personAddress?.city,
		[form.POST_CODE]: personAddress?.postCode,
		[form.STREET]: personAddress?.street,
		[form.HOUSE_NUMBER]: personAddress?.houseNumber,
		[form.TELEPHONE_PREFIX]: person?.telephonePrefix,
		[form.PHONE_NUMBER]: personPhoneNumber,
	};
};
